export var PROSE_NO_MARGINS = 'prose-p:my-0 prose-ul:my-0 prose-ol:my-0 prose-li:my-0 prose-h1:my-0 prose-h2:my-0 prose-h3:my-0 prose-h4:my-0 prose-h5:my-0 prose-h6:my-0 prose-blockquote:my-0 prose-hr:my-0';
